export default __webpack_public_path__ + "static/media/NCEritrea.ddf037ce.png";